export default __webpack_public_path__ + "f08a615b0eb5d6860ad45cbf0e2effaf.png";